import { withInstall } from '@element-plus/utils/with-install'
import Result from './src/result.vue'

export const ElResult = withInstall(Result)

export default ElResult

export * from './src/result'
